module.exports = __webpack_public_path__ + "fonts/46bb03668fd34f59f9def25971b8cb5f.svg";